import { useState, useEffect } from "react";

export function useMockLoading(delay = 600) {
  const [loading, setLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), delay);
    return () => clearTimeout(timer);
  }, [delay, reloadKey]);

  return { loading, reload: () => setReloadKey((k) => k + 1) };
}